(() => {
  const modalOpen = $("[data-modal-open]");
  const modalClose = $("[data-modal-close]");
  const modalContainer = $("[data-modal-container]");
  let bg = '<div class="modal-backdrop in"></div>';
  const closeClickingOffModal = event => {
    if (event.currentTarget === event.target) {
      modalClose.trigger("click");
    }
  };

  const closeModalByEscape = event => {
    const {
      originalEvent: { keyCode }
    } = event;

    if (keyCode === 27) {
      modalClose.trigger("click");
    }
  };

  const openModalContainer = (event, self) => {
    event.preventDefault();
    const modalId = self.attr("data-modal-open");
    const modalContainer = $(`[data-modal-container=${modalId}]`);

    $("body").css("overflow", "hidden");

    modalContainer.fadeIn(200);
    $("body").prepend(bg);
  };

  const closeModalContainer = (event, self) => {
    const modalId = self.attr("data-modal-close");
    const modalContainer = $(`[data-modal-container=${modalId}]`);

    $(".modal-backdrop").length > 0 && $(".modal-backdrop").remove();
    $("body").css("overflow", "auto");

    modalContainer.fadeOut(200);
  };

  modalOpen.on("click", function() {
    let self = $(this);

    openModalContainer(event, self);
  });
  modalClose.on("click", function() {
    let self = $(this);

    closeModalContainer(event, self);
  });
  modalContainer.on("click", closeClickingOffModal);
  $(document).on("keyup", closeModalByEscape);
})();
